import { render, staticRenderFns } from "./EffectivePolicyDateModal.vue?vue&type=template&id=0959bf08&scoped=true&"
import script from "./EffectivePolicyDateModal.vue?vue&type=script&lang=js&"
export * from "./EffectivePolicyDateModal.vue?vue&type=script&lang=js&"
import style0 from "./EffectivePolicyDateModal.vue?vue&type=style&index=0&id=0959bf08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0959bf08",
  null
  
)

export default component.exports